import { ValidatorUserSocial, Virtual } from '../interfaces';
import { PaginationResponse } from '../interfaces/PaginationInterface';
import client from './client';
import { qsStringify } from '../shared/utils/QueryString';
import { Contribution } from './contribution.api';

interface ValidatorByVirtualQuery {
  virtualId: number;
  name?: string;
  address?: string;
}

export interface Validator {
  id: number;
  team: string;
  createdAt: string;
  updatedAt: string;
  virtual: Virtual;
  contributions: Contribution[];
}

// Get validators by virtual ID
const getValidatorsByVirtual = async (query: ValidatorByVirtualQuery) => {
  const queryString = qsStringify({
    filters: {
      name: query.name,
      address: query.address,
    },
  });

  const url = `/api/virtuals/${query.virtualId}/validators?${queryString}`;
  const res = await client.get<PaginationResponse<ValidatorUserSocial[]>>(url);

  return res.data;
};

const getValidatorList = async () => {
  const url = `/api/validators`;
  const res = await client.get<{
    data: Validator[];
    meta: {
      pagination: {
        total: number;
        pageSize: number;
        page: number;
        pageCount: number;
      };
    };
  }>(url, {
    params: {
      populate: 'virtual, virtual.image, virtual.contributions',
      sort: 'createdAt:desc',
      // 'filters[virtual][contributions][status][$eq]': "DRAFT"
      // 'pagination[pageSize]': pageSize,
      // 'pagination[page]': page,
    },
  });

  return res.data;
};

const updateValidatorOnChain = async (data: { virtualId: number }) => {
  const res = await client.post(`/api/validators/onchain`, data);

  return res;
};

export { getValidatorsByVirtual, getValidatorList, updateValidatorOnChain };
